import { memo, type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFile } from '@mui/icons-material';
import { styled, Typography } from '@mui/material';

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})(({ disabled }: { disabled?: boolean }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  cursor: !disabled ? 'pointer' : 'default',
}));

interface Props {
  isDisable?: boolean;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

const PlaceholderBase = ({ onClick, isDisable }: Props) => {
  const { t } = useTranslation();

  return (
    <Wrapper onClick={onClick} disabled={isDisable}>
      <UploadFile fontSize="large" />
      <Typography align="center">{isDisable ? null : t('flow.modulesAndAgendas.form.item.fileUpload.text')}</Typography>
    </Wrapper>
  );
};

export const Placeholder = memo(PlaceholderBase) as typeof PlaceholderBase;
